const PaymentFrequencyEnum = Object.freeze({
    NO_AUTO: 'NO_AUTO',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY'
});

export default PaymentFrequencyEnum;
